
var sprite = require("/tmp/build_27def88f/node_modules/svg-sprite-loader/lib/web/global-sprite");
var image = "<symbol id=\"chevron_down_small_jax_9c74f6c45132cf09114dfddc4f4f727c\" ><path d=\"M8.972 4.48a.36.36 0 0 1 .536.48l-3.24 3.6a.36.36 0 0 1-.536 0l-3.24-3.6a.36.36 0 0 1 .536-.48L6 7.781l2.972-3.303z\" fill=\"#9099A7\"/><mask id=\"chevron_down_small_jax_9c74f6c45132cf09114dfddc4f4f727c_a\" maskUnits=\"userSpaceOnUse\" x=\"2\" y=\"4\" width=\"8\" height=\"5\"><path d=\"M8.972 4.48a.36.36 0 0 1 .536.48l-3.24 3.6a.36.36 0 0 1-.536 0l-3.24-3.6a.36.36 0 0 1 .536-.48L6 7.781l2.972-3.303z\" fill=\"#fff\"/></mask></symbol>";
module.exports = sprite.add(image, "chevron_down_small_jax_9c74f6c45132cf09114dfddc4f4f727c");


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/chevron_down_small.svg
// module id = 1271
// module chunks = 1